import { useLocation } from 'react-router-dom'
import HandIcon from 'assets/images/easyPay/init.svg'
import Header from 'components/headers/addLoan'
import style from './final.module.scss'
import useSEtFinalCashout from '../hooks/useSEtFinalCashout'
import useSetCashouts from '../hooks/useSetCashouts'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
export default function Final() {
    const { state } = useLocation()
    const { mutate } = useSEtFinalCashout()
    const { mutate: mutateJustAdd } = useSetCashouts()

    /**
     * This screen used to rebuild the payload field by field and silently drop
     * whatever it did not list — which is how `withdrawal_request` never once
     * reached the server: eighteen درخواست برداشت were filed, two were paid,
     * and not a single payment was ever joined to its request, so every one of
     * them still showed «در انتظار پرداخت» to the member and stayed in the
     * manager's cartable. Pass the payload through instead of retyping it.
     */
    const payload: IGetCardsPayloadFinal = { ...state?.data }

    return (
        <div className=" h-screen relative flex flex-col">
            <div className=" grow-0">
                <Header title="" />
            </div>
            <div className=" grow">
                <div className=" relative">
                    <img
                        src={HandIcon}
                        alt="hand"
                        className=" mx-auto absolute -top-16 z-50 right-32"
                    />

                    <div className={style['StyledReceipt']}>
                        <div>
                            <p className=" text-gray-1">واریز به حساب:</p>
                            <p>{state?.data?.name}</p>
                        </div>
                        <hr className=" my-2" />
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">مبلغ برداشت:</p>
                            <p>
                                {state?.data?.amount &&
                                    Number(
                                        state?.data?.amount
                                    ).toLocaleString()}{' '}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">هزینه اشتراک:</p>
                            <p>0 تومان</p>
                        </div>
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1"> بابت:</p>
                            <p>ّبرداشت از صندوق</p>
                        </div>

                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">نام صندوق:</p>
                            <p>{state?.data?.fundName}</p>
                        </div>

                        <hr className=" my-4" />
                        {/* Same word as the row above it, same number —
                            «مبلغ» twice read as a disagreement. A withdrawal
                            carries no commission, so the total IS the amount;
                            say which one this is. */}
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1"> مبلغ کل:</p>
                            <p>
                                {state?.data?.amount &&
                                    Number(
                                        state?.data?.amount
                                    ).toLocaleString()}{' '}
                                تومان
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" grow-0">
                <div className=" w-full">
                    <div className=" w-full">
                        <div
                            className=" mx-8 rounded-xl  bg-green-1 text-white text-center py-2.5 my-2 cursor-pointer"
                            onClick={() => {
                                // Without a destination account the server
                                // debits the fund's «موجودی نزد همیان» and the
                                // transfer never enters the bank queue — the
                                // money simply stops. Refuse here rather than
                                // showing «برداشت با موفقیت ثبت شد» over it.
                                if (!payload.bank_account) {
                                    // counts how often the card picker leaves
                                    // a manager with nothing selected — the
                                    // condition that stranded the money
                                    posthog.capture(
                                        'fund_withdrawal_blocked_no_card',
                                        {
                                            moneypool_id: payload.moneyPool,
                                            withdrawal_request:
                                                payload.withdrawal_request,
                                        }
                                    )
                                    toast.error(
                                        'شماره کارت یا حساب مقصد را انتخاب کنید'
                                    )
                                    return
                                }
                                mutate(payload)
                            }}
                        >
                            برداشت
                        </div>
                    </div>
                    <div className=" w-full">
                        <div
                            onClick={() => {
                                // record only: no money leaves Hamyan, so
                                // there is no account to name
                                mutateJustAdd(payload)
                            }}
                            className=" mx-8 rounded-xl  bg-transparent text-green-1 text-center py-2.5 my-2 cursor-pointer border-1 border-green-1"
                        >
                            برداشت تنها ثبت شود
                        </div>
                    </div>
                </div>{' '}
            </div>
        </div>
    )
}
